import { fetchUser } from "@/store/user/user.slice"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { Outlet } from "react-router-dom"

export const CheckoutLayout = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchUser())
  }, [])
  
  return <div className="full-screen">
    <Outlet key={'Checkout'} />
  </div>
}